import moment from 'moment';
import { Typography } from '../../../Typography/typography';
import styles from './EmployerPortalJobDetail.module.css';
import { t } from 'i18next';

export const jobDetailHeader = ({ title, country, city, createdAt }) => {
    return (
        <div className={styles.jobTitleHeader}>
            <div>
                <Typography title={title} weight={'600'} fontSize={22} />
                <Typography title={t('general.country.' + country) + ", " + t('general.city.' + city)} weight={'400'} fontSize={14} color={"#434546"} />
            </div>
            <div>
                <Typography title={t('employerPortalJobDetail.posted_on') + moment(createdAt).format("MMM Do YY")} weight={'400'} fontSize={14} color={"#434546"} />
            </div>
        </div>
    )
}